module.exports = __webpack_public_path__ + "img/网站-03.c0a0103c.jpg";